(() => {
  if (window.__catalystCardDemoReady) return;
  window.__catalystCardDemoReady = true;
  const audio = new Audio();
  audio.preload = 'none';
  let activeButton = null;
  const containerFor = (button) => button?.closest('.card-gallery, .resource-card__media, .cs-pack-art') || null;
  const setProgress = (button, value) => {
    const bar = button?.querySelector('[data-cs-demo-progress]');
    if (bar) bar.style.width = Math.max(0, Math.min(100, value)) + '%';
  };
  const setButtonState = (button, state) => {
    if (!button) return;
    const icon = button.querySelector('[data-cs-demo-icon]');
    const title = button.dataset.csDemoTitle || 'sample pack';
    button.classList.toggle('is-playing', state === 'playing');
    button.classList.toggle('is-loading', state === 'loading');
    containerFor(button)?.classList.toggle('is-demo-playing', state === 'playing');
    if (icon) icon.textContent = state === 'playing' ? 'Ⅱ' : (state === 'loading' ? '…' : '▶');
    button.setAttribute('aria-label', state === 'playing' ? 'Pause audio demo for ' + title : 'Play audio demo for ' + title);
  };
  const stopActive = (resetProgress = false) => {
    if (!activeButton) return;
    setButtonState(activeButton, 'idle');
    if (resetProgress) setProgress(activeButton, 0);
  };
  document.addEventListener('click', async (event) => {
    const button = event.target instanceof Element ? event.target.closest('[data-cs-demo-button]') : null;
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();
    const src = button.dataset.csDemoSrc;
    if (!src) return;
    if (activeButton === button) {
      if (!audio.paused) { audio.pause(); setButtonState(button, 'idle'); }
      else { try { setButtonState(button, 'loading'); await audio.play(); setButtonState(button, 'playing'); } catch (_) { setButtonState(button, 'idle'); } }
      return;
    }
    if (activeButton) { audio.pause(); stopActive(true); }
    activeButton = button;
    setButtonState(button, 'loading');
    try { audio.src = src; audio.currentTime = 0; await audio.play(); setButtonState(button, 'playing'); }
    catch (_) { setButtonState(button, 'idle'); activeButton = null; }
  }, true);
  audio.addEventListener('timeupdate', () => {
    if (!activeButton || !audio.duration || !Number.isFinite(audio.duration)) return;
    setProgress(activeButton, (audio.currentTime / audio.duration) * 100);
  });
  audio.addEventListener('ended', () => { if (!activeButton) return; const finished = activeButton; setButtonState(finished, 'idle'); setProgress(finished, 0); activeButton = null; });
  audio.addEventListener('error', () => { if (!activeButton) return; const failed = activeButton; setButtonState(failed, 'idle'); setProgress(failed, 0); activeButton = null; });
  document.addEventListener('play', (event) => { if (event.target instanceof HTMLAudioElement && event.target !== audio && activeButton) { audio.pause(); stopActive(false); } }, true);
})();

(() => {
  const addCatalogueCta = () => {
    const marquee = document.querySelector('.cs-product-marquee');
    if (!marquee || document.querySelector('.cs-catalogue-cta')) return;
    const section = document.createElement('section');
    section.className = 'cs-catalogue-cta cs-wrap';
    section.setAttribute('aria-labelledby', 'cs-catalogue-title');
    section.innerHTML = '<div class="cs-catalogue-cta-inner"><div class="cs-catalogue-copy"><p class="cs-kicker">EXPLORE CATALYST</p><h2 id="cs-catalogue-title">Browse our whole catalogue</h2><p>Explore every Catalyst pack by genre, mood and style.</p></div><a class="cs-btn cs-catalogue-btn" href="/collections/all">VIEW ALL PACKS <span aria-hidden="true">↗</span></a></div>';
    marquee.insertAdjacentElement('afterend', section);
  };
  const simplifyLatestReleases = () => {
    const section = document.querySelector('.cs-packs');
    if (!section) return;
    const kicker = section.querySelector('.cs-kicker');
    const heading = section.querySelector('h2');
    const intro = heading?.parentElement?.querySelector('p:not(.cs-kicker)');
    if (kicker) kicker.style.display = 'none';
    if (heading) heading.textContent = 'NEWEST RELEASES';
    if (intro) intro.textContent = 'Fresh out of the lab';
    const walker = document.createTreeWalker(section, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach((node) => {
      const text = node.nodeValue || '';
      if (/ANY PACKS\s*[·•]\s*BUILD A BUNDLE\s*[·•]\s*SAVE UP TO 25%/i.test(text)) node.nodeValue = text.replace(/ANY PACKS\s*[·•]\s*BUILD A BUNDLE\s*[·•]\s*SAVE UP TO 25%/i, 'BUILD YOUR OWN BUNDLE · SAVE UP TO 25% ON MULTIPLE PACKS');
      else if (/BUILD YOUR BUNDLE\s*[·•]\s*SAVE UP TO 25%/i.test(text)) node.nodeValue = text.replace(/BUILD YOUR BUNDLE\s*[·•]\s*SAVE UP TO 25%/i, 'BUILD YOUR OWN BUNDLE · SAVE UP TO 25% ON MULTIPLE PACKS');
    });
  };
  const tidyGenres = () => {
    const section = document.querySelector('.cs-genres');
    if (!section) return;
    const kicker = section.querySelector('.cs-kicker');
    const heading = section.querySelector('h2');
    if (kicker) kicker.textContent = 'FIND YOUR SOUND';
    if (heading) heading.textContent = 'GENRES';
    const cards = Array.from(section.querySelectorAll('a[href*="/collections/"]'));
    const visible = cards.filter((card) => !/\/collections\/fx(?:[/?#]|$)/i.test(card.getAttribute('href') || ''));
    cards.filter((card) => !visible.includes(card)).forEach((card) => card.remove());
    visible.sort((a, b) => {
      const aName = (a.querySelector('h3, h4')?.textContent || a.textContent || '').trim();
      const bName = (b.querySelector('h3, h4')?.textContent || b.textContent || '').trim();
      return aName.localeCompare(bName, undefined, { sensitivity: 'base' });
    });
    const parent = visible[0]?.parentElement;
    if (parent && visible.every((card) => card.parentElement === parent)) {
      visible.forEach((card, index) => {
        parent.appendChild(card);
        const number = card.querySelector('.cs-genre-num, [class*="genre-num"]');
        if (number) number.textContent = String(index + 1).padStart(2, '0');
      });
    }
  };
  const initCatalystHomepage = () => { addCatalogueCta(); simplifyLatestReleases(); tidyGenres(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initCatalystHomepage, { once: true });
  else initCatalystHomepage();
  document.addEventListener('shopify:section:load', initCatalystHomepage);
})();

/* CATALYST: SERIES & COLLECTION COMPLETION */
(() => {
  if (window.__catalystSeriesGroupsReady) return;
  window.__catalystSeriesGroupsReady = true;

  const groups = [
    { key:'808-sauce', title:'808 Sauce', type:'series', handles:['808-sauce','808-sauce-2','808-sauce-3','808-sauce-4','808-sauce-part-5'] },
    { key:'cassette-drums-1980s', title:"Cassette Drums: 1980's Collection", type:'series', handles:['cassette-drums-1980s-collection','cassette-drums-1980s-collection-vol-2','cassette-drums-1980s-collection-vol-3','cassette-drums-1980s-collection-vol-4','cassette-drums-1980s-collection-vol-5'] },
    { key:'crate-diggin', title:"Crate Diggin'", type:'series', handles:['crate-diggin','crate-diggin-vol-2'] },
    { key:'drum-breaks', title:'Drum Breaks', type:'series', handles:['drum-breaks','drum-breaks-vol-2'] },
    { key:'dynasty-trap', title:'Dynasty Trap', type:'series', handles:['dynasty-trap','dynasty-trap-vol-2'] },
    { key:'in-the-soul', title:'In The Soul', type:'series', handles:['in-the-soul','in-the-soul-vol-2','in-the-soul-vol-3','in-the-soul-vol-4'] },
    { key:'jazz-band-improvised', title:'Jazz Band Improvised', type:'series', handles:['jazz-band-improvised-sessions','jazz-band-improvised-the-sessions-vol-2'] },
    { key:'jazz-vibes', title:'Jazz Vibes', type:'series', handles:['jazz-vibes','jazz-vibes-vol-2','jazz-vibes-vol-3'] },
    { key:'medieval-trap', title:'Medieval Trap', type:'series', handles:['medieval-trap','medieval-trap-vol-2'] },
    { key:'melodic-tech-world', title:'Melodic Tech World', type:'series', handles:['melodic-tech-world','melodic-tech-world-2'] },
    { key:'old-skool-hip-hop', title:'Old Skool Hip Hop', type:'series', handles:['old-skool-hip-hop','old-skool-hip-hop-vol-2'] },
    { key:'organic-house', title:'Organic House', type:'series', handles:['organic-house','organic-house-vol-2'] },
    { key:'smooth-guitar-vibes', title:'Smooth Guitar Vibes', type:'series', handles:['smooth-guitar-vibes','smooth-guitar-vibes-vol-2'] },
    { key:'zero-gravity', title:'Zero Gravity', type:'series', handles:['zero-gravity','zero-gravity-vol-2'] },
    { key:'that-drums', title:'That Drum Series', type:'collection', handles:['that-dirty-south-slap','that-east-coast-knock','that-memphis-heat','that-west-coast-bounce'] },
    { key:'acoustic-drums', title:'Acoustic Drums', type:'collection', handles:['green-room-grooves','studio-drums','the-drum-anthology','indie-pop-drums'] }
  ];

  let timer = null;
  let running = false;
  const escapeHtml = (value) => String(value ?? '').replace(/[&<>'"]/g, (char) => ({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[char]));
  const cartHandle = (item) => item?.handle || item?.product_handle || '';

  const makeCard = (product, handle, currency) => {
    const variant = product?.variants?.find((item) => item.available !== false) || product?.variants?.[0];
    if (!variant) return '';
    const image = product.featured_image || product.images?.[0] || '';
    const price = new Intl.NumberFormat('en-GB', { style:'currency', currency:currency || 'GBP' }).format((product.price || variant.price || 0) / 100);
    const title = escapeHtml(product.title || handle);
    const href = '/products/' + encodeURIComponent(handle);
    return '<article class="cs-series-card" data-cs-series-card data-cs-series-handle="' + escapeHtml(handle) + '">' +
      '<a href="' + href + '" class="cs-series-card__image" aria-label="' + title + '">' +
        (image ? '<img src="' + escapeHtml(image) + '" alt="' + title + '" loading="lazy">' : '') +
      '</a>' +
      '<div class="cs-series-card__body">' +
        '<a class="cs-series-card__title" href="' + href + '">' + title + '</a>' +
        '<span class="cs-series-card__price">' + escapeHtml(price) + '</span>' +
        '<button type="button" class="cs-series-card__add" data-cs-series-add data-variant-id="' + escapeHtml(variant.id) + '"><span data-cs-series-label>+ ADD</span></button>' +
      '</div>' +
    '</article>';
  };

  const makeSection = (group, cards, missingCount) => {
    const section = document.createElement('section');
    const kicker = group.type === 'series' ? 'COMPLETE THE SERIES' : 'COMPLETE THE COLLECTION';
    section.className = 'cs-series-upsell';
    section.dataset.csSeriesUpsell = '';
    section.dataset.csSeriesKey = group.key;
    section.setAttribute('aria-label', 'Complete ' + group.title);
    section.innerHTML = '<div class="cs-series-upsell__head"><div><span class="cs-series-upsell__kicker">' + kicker + '</span><strong>' + escapeHtml(group.title) + '</strong></div><div class="cs-series-upsell__tools"><span class="cs-series-upsell__count">' + missingCount + ' LEFT</span><div class="cs-series-upsell__nav" aria-label="Series navigation"><button type="button" data-cs-series-prev aria-label="Previous related pack">←</button><button type="button" data-cs-series-next aria-label="Next related pack">→</button></div></div></div><div class="cs-series-upsell__track">' + cards + '</div><p class="cs-series-upsell__note">Add another pack to build your Chain Reaction discount.</p>';
    return section;
  };

  const sync = async () => {
    if (running) return;
    running = true;
    try {
      const cartResponse = await fetch('/cart.js', { headers:{Accept:'application/json'}, credentials:'same-origin' });
      if (!cartResponse.ok) return;
      const cart = await cartResponse.json();
      const orderedHandles = (cart.items || []).map(cartHandle).filter(Boolean);
      const inCart = new Set(orderedHandles);
      const paidHandles = (cart.items || []).filter((item) => Number(item.original_price ?? item.price) > 0).map(cartHandle).filter(Boolean);
      const activeGroup = paidHandles.map((handle) => groups.find((group) => group.handles.includes(handle))).find(Boolean);

      document.querySelectorAll('[data-cs-series-upsell]').forEach((section) => section.remove());
      if (!activeGroup) return;

      const missing = activeGroup.handles.filter((handle) => !inCart.has(handle));
      if (!missing.length) return;

      const products = await Promise.all(missing.map(async (handle) => {
        try {
          const response = await fetch('/products/' + encodeURIComponent(handle) + '.js', { headers:{Accept:'application/json'}, credentials:'same-origin' });
          if (!response.ok) return null;
          return { handle, product:await response.json() };
        } catch (_) { return null; }
      }));
      const cards = products.filter(Boolean).map(({handle, product}) => makeCard(product, handle, cart.currency || 'GBP')).filter(Boolean).join('');
      if (!cards) return;
      document.querySelectorAll('.cart__ctas').forEach((ctas) => {
        const parent = ctas.parentElement;
        if (!parent || parent.querySelector('[data-cs-series-key="' + activeGroup.key + '"]')) return;
        parent.insertBefore(makeSection(activeGroup, cards, missing.length), ctas);
      });
    } finally { running = false; }
  };

  const schedule = () => { window.clearTimeout(timer); timer = window.setTimeout(sync, 80); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule, {once:true});
  else schedule();
  document.addEventListener('catalyst:cart-mutated', schedule);
  document.addEventListener('cart:update', schedule);
  document.addEventListener('shopify:cart:lines-update', schedule);
  document.addEventListener('shopify:section:load', schedule);
})();


